import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { SingleLineTabs, TabContent, CircularLoader } from 'web-components-ts';
import UserManagementContent from './UserManagementContent';
import { loadUsers } from '../../redux/users/actions';
import { getUsers } from '../../redux/rootSelectors';

const ConnectedUserManagementContent = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { loadingState, data } = useSelector(getUsers);

  useEffect(() => {
    dispatch(loadUsers());
  }, [dispatch]);

  const activeUsers = data.filter((entry: { is_active: boolean }) => entry.is_active === true);
  const pendingUsers = data.filter((entry: { is_active: boolean }) => entry.is_active === false);

  const tabContent: TabContent[] = [
    {
      dataTestId: 'active-users-tab',
      title: t(`user_management.active`),
      content: (
        <UserManagementContent
          loadingState={loadingState}
          reloadAction={() => dispatch(loadUsers())}
          users={activeUsers}
          selectedTab="active"
          loadingComponent={() => <CircularLoader />}
          errorComponent={null}
          ignoreError={false}
        />
      )
    },
    {
      dataTestId: 'pending-invitations-tab',
      title: t(`user_management.pending`),
      content: (
        <UserManagementContent
          loadingState={loadingState}
          reloadAction={() => dispatch(loadUsers())}
          users={pendingUsers}
          selectedTab="pending"
          loadingComponent={() => <CircularLoader />}
          errorComponent={null}
          ignoreError={false}
        />
      )
    }
  ];

  return (
    <div style={{ padding: '130px 5rem 0' }}>
      <SingleLineTabs tabContent={tabContent} selectedTab={{ index: 0, time: new Date().getTime() }} />
    </div>
  );
};

export default ConnectedUserManagementContent;
